import { data } from "../data";
import DisplayTraining from "./DisplayTraining";
export default function TrainingPrograms() {
  return (
    <section className="py-10 mt-16 lg:mt-20" id="training-program">
      <h2 className="text-center text-lg md:text-3xl font-black text-medium-black mb-16">
        Training Programs We Offer
      </h2>

      <div className="grid lg:grid-cols-3 bg-light-purple-opacity gap-3 lg:gap-5 mx-auto w-3/4 rounded-[20px] py-3">
        {data.map((eachData) => {
          return <DisplayTraining {...eachData} key={eachData.name} />;
        })}
      </div>
    </section>
  );
}
